import classNames from "classnames";
import React from "react";

import { Icon, IconName } from "../icon";
import { TransparentButton } from "../transparent-button";

interface IFloatingMenuItemProps {
	text: string | undefined;
	iconName: IconName;
	onClick: () => void;
	disabled?: boolean;
	badge?: boolean;
	isError?: boolean;
}

export function FloatingMenuItem({
	text,
	iconName,
	disabled,
	onClick,
	badge,
	isError,
}: IFloatingMenuItemProps) {
	const classes = classNames([
		{
			"floating-menu__badge--warning": !isError,
		},
		{
			"floating-menu__badge--error": isError,
		},
	]);
	return (
		<TransparentButton className="floating-menu__item" disabled={disabled} onClick={onClick}>
			<div className="floating-menu__item-icon">
				{badge && <span className={classes} />}

				<Icon iconName={iconName} />
			</div>

			<span className="floating-menu__item-text">{text}</span>
		</TransparentButton>
	);
}
